<!-- The Modal -->
<!--<script src="modal-pop-up.component.ts"></script>-->
<div id="myModal" class="modal">
  <!-- Modal content -->
  <div class="modal-content ">
    <span class="close" style="text-align: end;"><a href="javascript:void(0)" (click)="closePopUp()">&times;</a></span>
    <p class="success user-msg" [innerHTML]="responseMessage"></p>
  </div>
</div>
